import React, { useState, useRef, useEffect } from "react"
import { Tick, upArrow, downArrow } from "../../../assets/images"

export function Select({
  options = [],
  value,
  onChange,
  placeholder = "Select...",
  classes = "w-36",
  id,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)

  const toggleDropdown = () => setIsOpen(prev => !prev)

  const handleSelect = (val) => {
    onChange(val)
    setIsOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const selectedLabel = options.find(o => `${o.value}` === `${value}`)?.label || placeholder

  return (
    <div className={`relative ${classes}`} ref={ref}>
      <button
        id={id}
        onClick={toggleDropdown}
        className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <span className="line-clamp-1">{selectedLabel}</span>
        <img src={isOpen ? upArrow : downArrow} className="h-4 w-4 opacity-50" />
      </button>

      {isOpen && (
        <div className="absolute z-50 mt-1 bg-white max-h-60 w-full overflow-auto rounded-md border bg-popover text-popover-foreground shadow-md">
          {options.map((option) => {
            const isSelected = `${option.value}` === `${value}`;
            return (
              <div
                key={option.value}
                onClick={() => handleSelect(option.value)}
                className={`relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm
                  ${isSelected ? 'bg-ds-brand-lt text-ds-brand' : 'hover:bg-gray-100 hover:text-black'}
                `}
              >
                {isSelected && (
                  <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
                    <img src={Tick} className="h-4 w-4" />
                  </span>
                )}
                {option.label}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
